const rootState = {
    parent: 'root',
    url: '',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const usersRootState = {
    parent: 'root',
    url: '/users',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const userListState = {
    url: '',
    template: require('./users/controllers/list/userlist.html'),
    controller: require('./users/controllers/list/userlistCtrl'),
    requireToken: true
};

const userAddState = {
    url: '/add',
    template: require('./users/controllers/add/addUser.html'),
    controller: require('./users/controllers/add/addUserCtrl'),
    controllerAs: 'addUser'
};

const userEditState = {
    url: '/edit/:userId',
    template: require('./users/controllers/edit/editUser.html'),
    controller: require('./users/controllers/edit/editUserCtrl'),
    controllerAs: 'editUser'
};

const userViewState = {
    url: '/view/:userId',
    template: require('./users/controllers/view/viewUser.html'),
    controller: require('./users/controllers/view/viewUserCtrl'),
    controllerAs: 'viewUser'
};

const userDeleteState = {
    url: '/delete/:userId',
    template: require('./users/controllers/delete/deleteUser.html'),
    controller: require('./users/controllers/delete/deleteUserCtrl'),
    controllerAs: 'deleteUser'
};

export default function (app) {
    app.config(($stateProvider, userRolesObject) => {
        // View access to admin, operator and teamlead
        userListState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
        };

        userViewState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
        };

        // Add and delete access to admin, teamlead
        userAddState.data = {
            roles: [userRolesObject.admin, userRolesObject.teamLead]
        };

        userDeleteState.data = {
            roles: [userRolesObject.admin, userRolesObject.teamLead]
        };

        // Edit access to admin
        userEditState.data = {
            roles: [userRolesObject.admin, userRolesObject.teamLead]
        };

        $stateProvider.state('admin', rootState);
        $stateProvider
            .state('users', usersRootState)
            .state('users.list', userListState)
            .state('users.add', userAddState)
            .state('users.edit', userEditState)
            .state('users.delete', userDeleteState)
            .state('users.view', userViewState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/admin/routes.js